// Import custom transition functions from the Timedoor module.
// import { slideUp, slideDown, slideToggle, fadeOut, fadeIn, fadeToggle } from './modules/transitions';
// Import specific Bootstrap components for modular use in the project.
// import Offcanvas from 'bootstrap/js/dist/offcanvas';
// import Modal from 'bootstrap/js/dist/modal';
// import Tabs from 'bootstrap/js/dist/tab';

/**
 * Coding Standards
 * ===========================
 * 1. Functionality Splitting:
 *    - Create distinct, single-purpose functions to improve readability and reusability.
 * 2. Modular Imports:
 *    - Import only the required modules to reduce bundle size and enhance maintainability.
 * 3. Event Listeners:
 *    - Always wrap initialization code inside `DOMContentLoaded` to ensure the DOM is fully loaded.
 */

// ==========================
// NAV
// ==========================
function initNavigation() {
	const hamburger = document.querySelector('.header__hamburger');
	const nav = document.querySelector('.header__nav');
	const header = document.querySelector('.header');
	const offset = 10;

	if (!hamburger || !nav || !header) return;

	hamburger.addEventListener('click', () => {
		hamburger.classList.toggle('active');
		nav.classList.toggle('active');
		header.classList.toggle('is-open');
	});

	nav.querySelectorAll('a').forEach(link => {
		link.addEventListener('click', e => {
			const href = link.getAttribute('href');

			// Check if it's an anchor link
			if (href.includes('#')) {
				const url = new URL(href, window.location.origin);

				// Check if it's same page
				if (url.pathname === window.location.pathname) {
					e.preventDefault();

					const targetId = url.hash.replace('#', '');
					const targetEl = document.getElementById(targetId);

					if (targetEl) {
						targetEl.scrollIntoView({ behavior: 'smooth' });
					}

					// Close menu
					hamburger.classList.remove('active');
					nav.classList.remove('active');
					header.classList.remove('is-open');
				}
			}
		});
	});

	window.addEventListener('scroll', () => {
		if (window.scrollY > offset) {
			header.classList.add('header_scrolled');
		} else {
			header.classList.remove('header_scrolled');
		}
	});
}

// ==========================
// CONTACT
// ==========================
function contactTab() {
	const tabButtons = document.querySelectorAll('.contact__tab-btn');
	const forms = document.querySelectorAll('.contact__form');

	if (!tabButtons.length || !forms.length) return;

	tabButtons.forEach(button => {
		button.addEventListener('click', () => {
			tabButtons.forEach(btn => btn.classList.remove('contact__tab-btn--active'));
			button.classList.add('contact__tab-btn--active');

			const target = button.dataset.target;

			forms.forEach(form => {
				if (form.dataset.form === target) {
					form.classList.add('contact__form--active');
				} else {
					form.classList.remove('contact__form--active');
				}
			});
		});
	});
}

function emailValidation() {
	const email = document.querySelector('[name="inputEmail"]');
	const confirm = document.querySelector('[name="emailConfirm"]');

	if (!email || !confirm) return;

	const validate = () => {
		const isValid = email.value === confirm.value;

		if (email.value && confirm.value && !isValid) {
			confirm.setCustomValidity('メールアドレスが一致しません');
			confirm.classList.add('is-error');
		} else {
			confirm.setCustomValidity('');
			confirm.classList.remove('is-error');
		}
	};

	email.addEventListener('input', validate);
	confirm.addEventListener('input', validate);
}

function furiganaValidation() {
	const inputs = document.querySelectorAll('[name="inputFurigana"]');

	if (!inputs.length) return;
	const katakanaRegex = /^[\u3040-\u309F\u30A0-\u30FFー\s]+$/;

	inputs.forEach(input => {
		input.addEventListener('input', function () {
			if (this.value && !katakanaRegex.test(this.value)) {
				this.setCustomValidity('ひらがな・カタカナで入力してください');
				this.classList.add('is-error');
			} else {
				this.setCustomValidity('');
				this.classList.remove('is-error');
			}
		});

		input.addEventListener('blur', function () {
			const before = this.value;
			const after = before.replace(/[^\u3040-\u309F\u30A0-\u30FFー\s]/g, '');
			if (before !== after) {
				this.value = after;
			}

			if (this.value && !katakanaRegex.test(this.value)) {
				this.setCustomValidity('ひらがな・カタカナで入力してください');
				this.classList.add('is-error');
			} else {
				this.setCustomValidity('');
				this.classList.remove('is-error');
			}
		});
	});
}

function initContactFormProtection() {
	document.addEventListener('wpcf7beforesubmit', function (event) {
		const form = event.target;
		const submitBtn = form.querySelector('input[type="submit"], button[type="submit"]');
		if (submitBtn) {
			submitBtn.disabled = true;
			submitBtn.textContent = 'Sending...';
		}
	});

	document.addEventListener('wpcf7invalid', function (event) {
		const form = event.target;
		const submitBtn = form.querySelector('input[type="submit"], button[type="submit"]');
		if (submitBtn) {
			submitBtn.disabled = false;
			submitBtn.textContent = 'Submit';
		}
	});

	document.addEventListener('wpcf7mailfailed', function (event) {
		const form = event.target;
		const submitBtn = form.querySelector('input[type="submit"], button[type="submit"]');
		if (submitBtn) {
			submitBtn.disabled = false;
			submitBtn.textContent = 'Submit';
		}
	});

	document.addEventListener('wpcf7mailsent', function (event) {
		const form = event.target;
		const submitBtn = form.querySelector('input[type="submit"], button[type="submit"]');
		if (submitBtn) {
			submitBtn.disabled = true;
			submitBtn.textContent = 'Sent!';
		}
	});
}

function initPhoneValidator() {
	// Allow: digits, +, -, spaces, ( ) — any format, 8–15 digits total
	function isValidPhone(val) {
		if (val === '') return true;
		const formatOk = /^[+\d()\-\s]+$/.test(val);
		const digitCount = val.replace(/\D/g, '').length;
		return formatOk && digitCount >= 7 && digitCount <= 15;
	}

	function validatePhone(input) {
		const val = input.value.trim();
		const wrap = input.closest('.wpcf7-form-control-wrap');

		if (val === '' || isValidPhone(val)) {
			input.setCustomValidity('');
			input.classList.remove('wpcf7-not-valid');
			wrap?.querySelector('.wpcf7-not-valid-tip')?.remove();
		} else {
			input.setCustomValidity('有効な電話番号を入力してください。例: 03-1234-5678');
			input.classList.add('wpcf7-not-valid');
			if (wrap && !wrap.querySelector('.wpcf7-not-valid-tip')) {
				const tip = document.createElement('span');
				tip.className = 'wpcf7-not-valid-tip';
				tip.textContent = '有効な電話番号を入力してください。例: 03-1234-5678';
				wrap.appendChild(tip);
			}
		}
	}

	document.querySelectorAll('input[type="tel"], .wpcf7-tel').forEach(input => {
		input.addEventListener('input', () => validatePhone(input));
		input.addEventListener('blur', () => validatePhone(input));
	});

	// CF7 submits via AJAX — setCustomValidity alone won't block it.
	// Validate all tel inputs on beforesubmit and prevent if any are invalid.
	document.addEventListener('wpcf7beforesubmit', function (e) {
		const form = e.target;
		let blocked = false;

		form.querySelectorAll('input[type="tel"], .wpcf7-tel').forEach(input => {
			const val = input.value.trim();
			if (val !== '' && !isValidPhone(val)) {
				validatePhone(input);
				blocked = true;
			}
		});

		if (blocked) e.preventDefault();
	});
}

function initContactFormRedirect() {
	document.addEventListener('wpcf7mailsent', function () {
		window.location.href = '/contact-complete/';
	});
}

function initCharacterValidator() {
	// Allows: Latin (ASCII + Extended), Japanese (hiragana, katakana, kanji, punctuation)
	const allowedPattern = /^[\u0000-\u024F\u3000-\u303F\u3040-\u30FF\uFF00-\uFFEF\u4E00-\u9FFF\u3400-\u4DBF\uF900-\uFAFF]*$/;
	const stripPattern = /[^\u0000-\u024F\u3000-\u303F\u3040-\u30FF\uFF00-\uFFEF\u4E00-\u9FFF\u3400-\u4DBF\uF900-\uFAFF]/g;

	function applyValidator(form) {
		const inputs = form.querySelectorAll(
			'input[type="text"], input[type="tel"], input[type="number"], input:not([type])'
		);

		inputs.forEach(input => {
			// Block invalid chars before insertion (primary method)
			input.addEventListener('beforeinput', function (e) {
				if (e.isComposing) return;
				if (e.data && stripPattern.test(e.data)) e.preventDefault();
			});

			// Clean pasted content
			input.addEventListener('paste', function (e) {
				const raw = (e.clipboardData || window.clipboardData)?.getData('text') || '';
				const cleaned = raw.replace(stripPattern, '');
				if (raw !== cleaned) {
					e.preventDefault();
					try {
						document.execCommand('insertText', false, cleaned);
					} catch (_) {
						const start = this.selectionStart ?? this.value.length;
						const end = this.selectionEnd ?? this.value.length;
						this.value = this.value.substring(0, start) + cleaned + this.value.substring(end);
					}
				}
			});

			// Fallback strip for drag-drop, autocomplete, IME
			// Note: email inputs throw DOMException on selectionStart — set value before try/catch
			input.addEventListener('input', function (e) {
				if (e.isComposing) return;
				const before = this.value;
				const after = before.replace(stripPattern, '');
				if (before !== after) {
					this.value = after;
					try {
						const sel = this.selectionStart - (before.length - after.length);
						this.setSelectionRange(Math.max(0, sel), Math.max(0, sel));
					} catch (_) { }
				}
				if (this.value && !allowedPattern.test(this.value)) {
					this.setCustomValidity('絵文字や特殊文字は使用できません');
					this.classList.add('is-error');
				} else {
					this.setCustomValidity('');
					this.classList.remove('is-error');
				}
			});
		});
	}

	document.querySelectorAll('.wpcf7-form').forEach(applyValidator);

	document.addEventListener('wpcf7render', function (e) {
		const form = e.target?.querySelector('.wpcf7-form') || e.target;
		if (form) applyValidator(form);
	});
}

// ==========================
// FADE IN
// ==========================
function initFadeIn() {
	const fadeItems = document.querySelectorAll('.fade-in');

	if (!fadeItems.length) return;

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add('is-active');
				observer.unobserve(entry.target);
			}
		});
	}, {
		threshold: 0.2
	});

	fadeItems.forEach(item => {
		observer.observe(item);
	});
}

function initArchiveFilter() {
	const isNewsArchive = document.querySelector(".section_news-list");
	const isLiveArchive = document.querySelector(".section_live-list");

	if (!isNewsArchive && !isLiveArchive) return;

	let currentCategory = "all";
	let currentPage = 1;
	const archiveType = isNewsArchive ? "news" : "live";
	const actionName = isNewsArchive ? "filter_news" : "filter_live";

	function updateURL(category, page) {
		const url = new URL(window.location);

		if (archiveType === "news") {
			if (category === "all") {
				url.searchParams.delete("category");
			} else {
				url.searchParams.set("category", category);
			}
		}

		if (page === 1) {
			url.searchParams.delete("page");
		} else {
			url.searchParams.set("page", page);
		}

		window.history.pushState({}, "", url);
	}

	function fetchPosts(category = "all", page = 1) {
		updateURL(category, page);

		const loader = document.querySelector(".news-loading");
		const list = document.querySelector(".news-list");
		const pagination = document.querySelector(".pagination");

		const formData = new FormData();
		formData.append("action", actionName);
		if (archiveType === "news") {
			formData.append("category", category);
		}
		formData.append("page", page);

		if (loader) loader.classList.add("is-active");
		if (list) list.style.opacity = "0.3";

		fetch(ajax_obj.ajax_url, {
			method: "POST",
			body: formData
		})
			.then(res => res.json())
			.then(data => {
				if (list) list.innerHTML = data.posts;
				if (pagination) pagination.innerHTML = data.pagination;

				if (loader) loader.classList.remove("is-active");
				if (list) list.style.opacity = "1";

				initFadeIn();
				scrollToTop();

				// Give Safari enough time to calculate layout (image sizes, fonts) before clamping
				let _ajaxClampTimer = setTimeout(() => {
					initNewsClamping();
				}, 100);

				// Re-clamp AJAX-loaded posts on resize (debounced)
				if (list._resizeHandler) {
					window.removeEventListener('resize', list._resizeHandler);
				}
				list._resizeHandler = () => {
					clearTimeout(_ajaxClampTimer);
					_ajaxClampTimer = setTimeout(() => {
						initNewsClamping();
					}, 200);
				};
				window.addEventListener('resize', list._resizeHandler);
			});
	}

	function getInitialState() {
		const params = new URLSearchParams(window.location.search);

		return {
			category: params.get("category") || "all",
			page: parseInt(params.get("page")) || 1
		};
	}

	// INITIAL LOAD
	const init = getInitialState();
	currentCategory = init.category;
	currentPage = init.page;

	fetchPosts(currentCategory, currentPage);

	function scrollToTop() {
		const section = isNewsArchive || isLiveArchive;

		if (!section) return;

		window.scrollTo({
			top: section.offsetTop - 80,
			behavior: "smooth"
		});
	}


	// CATEGORY CLICK (PC)
	if (archiveType === "news") {
		document.querySelectorAll(".news-category__item").forEach(item => {
			item.addEventListener("click", () => {
				document.querySelectorAll(".news-category__item").forEach(i => i.classList.remove("is-active"));
				item.classList.add("is-active");

				currentCategory = item.dataset.category;
				currentPage = 1;
				fetchPosts(currentCategory, currentPage);
			});
		});

		// SELECT (SP)
		document.getElementById("news-select")?.addEventListener("change", (e) => {
			currentCategory = e.target.value;
			currentPage = 1;
			fetchPosts(currentCategory, currentPage);
		});
	}

	// PAGINATION
	document.addEventListener("click", (e) => {
		const target = e.target.closest(".pagination__number, .pagination__arrow");

		if (target) {
			e.preventDefault();
			if (target.classList.contains("is-disabled")) return;

			const page = target.dataset.page;
			if (!page) return;

			currentPage = parseInt(page, 10);
			fetchPosts(currentCategory, currentPage);
		}
	});

	document.querySelectorAll(".pagination__number").forEach(el => {
		el.classList.remove("is-active");
	});
}

// ==========================
// News Text Clamping
// ==========================
// function initNewsClamping() {
// 	function getLineHeight(el) {
// 		const lh = parseFloat(getComputedStyle(el).lineHeight);
// 		if (!isNaN(lh)) return lh;
// 		return parseFloat(getComputedStyle(el).fontSize) * 1.2;
// 	}

// 	function clampByLines(selector, maxLines, maxChars = null) {
// 		document.querySelectorAll(selector).forEach(el => {
// 			// Save the original full text once; restore from it on every call
// 			if (!el.dataset.originalText) {
// 				el.dataset.originalText = el.textContent.trim();
// 			}
// 			const originalText = el.dataset.originalText;

// 			// Restore full text before measuring so wider screens show more
// 			el.textContent = originalText;

// 			const lineHeight = getLineHeight(el);
// 			const maxHeight = Math.ceil(lineHeight * maxLines);

// 			el.style.overflow = 'visible';
// 			el.style.maxHeight = 'none';
// 			el.style.webkitLineClamp = 'unset';
// 			el.style.display = 'block';

// 			// Apply character limit first (caps the source text)
// 			let text = maxChars && originalText.length > maxChars
// 				? originalText.slice(0, maxChars)
// 				: originalText;

// 			el.textContent = text;

// 			// If it fits within the line limit, nothing more to do
// 			if (el.scrollHeight <= maxHeight) return;

// 			// Binary-search for the longest substring that still fits
// 			let lo = 0, hi = text.length;
// 			while (lo < hi) {
// 				const mid = Math.ceil((lo + hi) / 2);
// 				el.textContent = text.slice(0, mid) + '...';
// 				if (el.scrollHeight <= maxHeight) {
// 					lo = mid;
// 				} else {
// 					hi = mid - 1;
// 				}
// 			}

// 			el.textContent = text.slice(0, lo) + '...';
// 		});
// 	}

// 	clampByLines('.top__news .news__title', 2);
// 	clampByLines('.news-list .news__title, .news__list .news__title', 2);
// 	clampByLines('.news-list .news__text, .news__list .news__text', 3, 200);
// }

// ==========================
// TOPIC Swiper
// ==========================
function initTopicSwiper() {
	const topicEl = document.querySelector('.swiper_topic');

	if (!topicEl) return;

	const slideCount = topicEl.querySelectorAll('.swiper-slide').length;
	const topicSwiper = new Swiper('.swiper_topic', {
		loop: slideCount > 1,
		slidesPerView: 2.5,
		centeredSlides: true,
		spaceBetween: 40,
		speed: 1000,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		breakpoints: {
			0: {
				slidesPerView: 1.2,
				spaceBetween: 20,
			},
			800: {
				slidesPerView: 2.5,
				spaceBetween: 40,
			},
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		}
	});

	topicEl.addEventListener('mouseenter', () => {
		topicSwiper.autoplay.stop();
	});

	topicEl.addEventListener('mouseleave', () => {
		topicSwiper.autoplay.start();
	});
}

// ==========================
// MEMBER MODAL Swiper & Controls
// ==========================
function initMemberSwiper() {
	const memberSwiper = new Swiper('.swiper_member', {
		loop: true,
		speed: 400,
		threshold: 5,
		navigation: {
			nextEl: '.swiper_member .swiper-button-next',
			prevEl: '.swiper_member .swiper-button-prev',
		},
	});

	function updateMemberNavNames() {
		const realSlides = Array.from(this.slides).filter(slide =>
			!slide.classList.contains('swiper-slide-duplicate')
		);

		const total = realSlides.length;
		const current = this.realIndex;

		const nextIndex = (current + 1) % total;
		const prevIndex = (current - 1 + total) % total;

		const nextName = realSlides[nextIndex].dataset.member.toUpperCase();
		const prevName = realSlides[prevIndex].dataset.member.toUpperCase();

		const nextEl = document.querySelector('.member-nav__name--next');
		const prevEl = document.querySelector('.member-nav__name--prev');

		if (nextEl) nextEl.textContent = nextName;
		if (prevEl) prevEl.textContent = prevName;
	}

	memberSwiper.on('init slideChange', function () {
		updateMemberNavNames.call(this);
	});

	// Modal Control
	const modal = document.querySelector('.js-modal');
	const openBtns = document.querySelectorAll('.js-member-open');
	const closeBtns = document.querySelectorAll('.js-modal-close');

	if (!modal || !openBtns.length) return;

	const slides = Array.from(
		document.querySelectorAll('.swiper_member .swiper-slide')
	).filter(slide => !slide.classList.contains('swiper-slide-duplicate'));

	function closeModal() {
		modal.classList.remove('is-active');
		document.body.classList.remove('is-fixed');
		document.documentElement.classList.remove('is-fixed');
		document.body.style.paddingRight = "";
	}

	openBtns.forEach(btn => {
		btn.addEventListener('click', () => {
			const member = btn.dataset.member;

			const index = slides.findIndex(
				slide => slide.dataset.member === member
			);
			if (index === -1) return;

			document.documentElement.style.scrollBehavior = 'auto';
			const scrollBarWidth = window.innerWidth - document.body.clientWidth;
			modal.classList.add('is-active');
			document.body.classList.add('is-fixed');
			document.documentElement.classList.add('is-fixed');

			document.body.style.paddingRight = scrollBarWidth + "px";

			memberSwiper.slideToLoop(index, 0);
			updateMemberNavNames.call(memberSwiper);
		});
	});

	closeBtns.forEach(btn => {
		btn.addEventListener('click', closeModal);
	});

	modal.addEventListener('click', e => {
		if (e.target === modal) {
			closeModal();
		}
	});

	document.addEventListener('keydown', e => {
		if (e.key === 'Escape' && modal.classList.contains('is-active')) {
			closeModal();
		}
	});
}

// ==========================
// VOICE
// ==========================
function initVoice() {
	const voices = document.querySelectorAll('.voice');

	if (!voices.length) return;

	voices.forEach(voice => {
		const audio = voice.querySelector('audio');

		if (!audio) return;

		voice.addEventListener('click', () => {
			if (audio.paused) {
				audio.currentTime = 0;
				audio.play();
				voice.classList.add('is-playing');
			} else {
				audio.pause();
				voice.classList.remove('is-playing');
			}
		});

		audio.addEventListener('ended', () => {
			voice.classList.remove('is-playing');
		});
	});
}

// ==========================
// SCROLL
// ==========================
function initScroll() {
	const profileItems = document.querySelectorAll('.profile__item');

	if (!profileItems.length) return;

	profileItems.forEach(item => {
		item.addEventListener('scroll', function () {
			const slide = this.closest('.swiper-slide');

			if (this.scrollTop > 10) {
				slide.classList.add('is-scrolled');
			} else {
				slide.classList.remove('is-scrolled');
			}
		});
	});
}

// ==========================
// Initialize All Scripts on DOM Ready
// ==========================
document.addEventListener('DOMContentLoaded', () => {
	initNavigation();
	contactTab();
	furiganaValidation();
	emailValidation();
	initPhoneValidator();
	initContactFormProtection();
	initContactFormRedirect();
	initCharacterValidator();
	initFadeIn();
	initArchiveFilter();
	initTopicSwiper();
	initMemberSwiper();
	initVoice();
	initScroll();
	document.fonts.ready.then(() => {
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				initNewsClamping();
			});
		});
	});

	// Re-clamp on resize (debounced) for statically queried posts
	let _resizeTimer;
	window.addEventListener('resize', () => {
		clearTimeout(_resizeTimer);
		_resizeTimer = setTimeout(() => {
			initNewsClamping();
		}, 200);
	});
});

document.addEventListener('wpcf7render', () => {
	emailValidation();
});